

/**
 * @name Events
 * @description A simple factory storing events data
 * @return {object} Returns the Events object.
 */
function Events() {
  let Events = this;

  // Defaults
  Events.navSize = 'large';
  Events.chatOpen = false;
  Events.statsOpen = false;
  Events.loggedIn = false;
  Events.loading = false;
  Events.navActive = false;
  Events.secondaryNavActive = false;
  Events.artistStatsOpen = false;
  Events.statsDateRange = 'today';
  Events.newMessagesCount = 0;

  return Events;
}

angular
  .module('inkfinder')
  .factory('Events', Events);



// WEBPACK FOOTER //
// ./components/events/events.service.js